document.documentElement.classList.remove('no-js');

const menuToggle = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('#MobileMenu');

if (menuToggle && mobileMenu) {
  menuToggle.addEventListener('click', () => {
    const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!isOpen));
    mobileMenu.hidden = isOpen;
  });
}

document.querySelectorAll('.nav-dropdown').forEach((dropdown) => {
  let closeTimer;

  const openDropdown = () => {
    window.clearTimeout(closeTimer);
    document.querySelectorAll('.nav-dropdown[open]').forEach((other) => {
      if (other !== dropdown) other.removeAttribute('open');
    });
    dropdown.setAttribute('open', '');
  };

  const closeDropdown = () => {
    closeTimer = window.setTimeout(() => dropdown.removeAttribute('open'), 120);
  };

  dropdown.addEventListener('mouseenter', openDropdown);
  dropdown.addEventListener('mouseleave', closeDropdown);
  dropdown.addEventListener('focusin', openDropdown);
  dropdown.addEventListener('focusout', (event) => {
    if (!dropdown.contains(event.relatedTarget)) closeDropdown();
  });
});

document.addEventListener('click', (event) => {
  document.querySelectorAll('.nav-dropdown[open]').forEach((dropdown) => {
    if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
  });
});

const searchDrawer = document.querySelector('[data-search-drawer]');
const searchInput = document.querySelector('#HeaderSearchInput');
const searchClose = document.querySelector('[data-search-close]');
const searchToggles = [...document.querySelectorAll('[data-search-toggle]')];

const setSearchDrawer = (open) => {
  if (!searchDrawer) return;
  searchDrawer.hidden = !open;
  searchToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(open)));
  if (open) window.setTimeout(() => searchInput?.focus(), 20);
};

searchToggles.forEach((toggle) => toggle.addEventListener('click', () => setSearchDrawer(searchDrawer?.hidden)));
searchClose?.addEventListener('click', () => setSearchDrawer(false));
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    setSearchDrawer(false);
    document.querySelectorAll('.nav-dropdown[open]').forEach((dropdown) => dropdown.removeAttribute('open'));
  }
});

document.querySelectorAll('[data-predictive-search]').forEach((form) => {
  const input = form.querySelector('input[type="search"]');
  const results = document.querySelector('[data-predictive-results]');
  const endpoint = form.dataset.searchEndpoint;
  let timeout;
  let request;

  if (!input || !results || !endpoint) return;

  input.addEventListener('input', () => {
    window.clearTimeout(timeout);
    const term = input.value.trim();
    if (term.length < 2) {
      request?.abort();
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      return;
    }

    timeout = window.setTimeout(async () => {
      request?.abort();
      request = new AbortController();
      const url = `${endpoint}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
      try {
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) return;
        const markup = await response.text();
        const page = new DOMParser().parseFromString(markup, 'text/html');
        const section = page.querySelector('#shopify-section-predictive-search');
        results.innerHTML = section ? section.innerHTML : markup;
        input.setAttribute('aria-expanded', String(results.textContent.trim().length > 0));
      } catch (error) {
        if (error.name !== 'AbortError') input.setAttribute('aria-expanded', 'false');
      }
    }, 220);
  });
});

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const select = root.querySelector('.variant-select');
  const price = root.querySelector('[data-product-price]');
  const button = root.querySelector('.product-submit');
  const radios = [...root.querySelectorAll('input[name^="options["]')];
  const form = root.querySelector('.product-form');
  const stickyBar = root.querySelector('[data-sticky-product-bar]');
  const stickyButton = root.querySelector('[data-sticky-submit]');
  const stickyPrice = root.querySelector('[data-sticky-price]');
  const stickyVariant = root.querySelector('[data-sticky-variant]');
  const stickyImage = root.querySelector('.sticky-product-image');

  const showVariantMedia = (option) => {
    const mediaId = option?.dataset.mediaId;
    if (!mediaId) return;
    const control = root.querySelector(`.adaptive-gallery-control[data-media-id="${mediaId}"]`);
    if (!control || control.checked) return;
    control.checked = true;
    control.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const syncStickyBar = (option) => {
    if (!option) return;
    if (stickyPrice) stickyPrice.textContent = option.dataset.price;
    if (stickyVariant) stickyVariant.textContent = option.dataset.title === 'Default Title' ? '' : option.dataset.title;
    if (stickyImage && option.dataset.image) stickyImage.src = option.dataset.image;
    if (stickyButton) {
      stickyButton.disabled = option.disabled;
      stickyButton.textContent = option.disabled ? 'Sold out' : button?.textContent.trim() || 'Add to bag';
    }
  };

  stickyButton?.addEventListener('click', () => form?.requestSubmit(button));

  if (stickyBar && button) {
    let queued = false;
    const updateStickyVisibility = () => {
      queued = false;
      const purchasePassed = button.getBoundingClientRect().bottom < 0;
      const footer = document.querySelector('.site-footer');
      const footerReached = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      stickyBar.hidden = !purchasePassed || footerReached;
    };
    const queueVisibilityUpdate = () => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(updateStickyVisibility);
    };
    window.addEventListener('scroll', queueVisibilityUpdate, { passive: true });
    window.addEventListener('resize', queueVisibilityUpdate, { passive: true });
    updateStickyVisibility();
  }

  if (!select) return;
  syncStickyBar(select.selectedOptions[0]);
  showVariantMedia(select.selectedOptions[0]);
  if (radios.length === 0) return;

  radios.forEach((radio) => {
    radio.addEventListener('change', () => {
      const chosen = radios.filter((input) => input.checked).map((input) => input.value);
      const option = [...select.options].find((item) => chosen.every((value) => item.textContent.includes(value)));
      if (!option) return;
      select.value = option.value;
      price.textContent = option.dataset.price;
      button.disabled = option.disabled;
      syncStickyBar(option);
      showVariantMedia(option);
      window.history.replaceState({}, '', `${window.location.pathname}?variant=${option.value}`);
    });
  });
});

document.querySelectorAll('.adaptive-product-gallery').forEach((gallery) => {
  const controls = [...gallery.querySelectorAll('.adaptive-gallery-control')];
  const previous = gallery.querySelector('[data-adaptive-previous]');
  const next = gallery.querySelector('[data-adaptive-next]');
  const stage = gallery.querySelector('.adaptive-gallery-stage');
  let touchStart = 0;

  const fitActiveFrame = () => {
    const activeSlide = [...gallery.querySelectorAll('.adaptive-gallery-slide')].find((slide) => getComputedStyle(slide).display !== 'none');
    const media = activeSlide?.querySelector('.adaptive-gallery-image, .adaptive-gallery-video, .adaptive-gallery-model, .adaptive-gallery-external-video');
    if (!activeSlide || !media) return;

    activeSlide.style.removeProperty('--adaptive-slide-width');
    window.requestAnimationFrame(() => {
      const width = Math.ceil(media.getBoundingClientRect().width);
      if (width > 0) activeSlide.style.setProperty('--adaptive-slide-width', `${width}px`);
    });
  };

  const showMedia = (index) => {
    if (controls.length === 0) return;
    const nextIndex = (index + controls.length) % controls.length;
    controls[nextIndex].checked = true;
    controls[nextIndex].dispatchEvent(new Event('change', { bubbles: true }));
  };

  const activeIndex = () => controls.findIndex((control) => control.checked);

  controls.forEach((control) => control.addEventListener('change', () => {
    gallery.querySelectorAll('.adaptive-gallery-slide').forEach((slide) => {
      if (getComputedStyle(slide).display === 'none') slide.querySelectorAll('video').forEach((video) => video.pause());
    });
    window.requestAnimationFrame(fitActiveFrame);
  }));
  previous?.addEventListener('click', () => showMedia(activeIndex() - 1));
  next?.addEventListener('click', () => showMedia(activeIndex() + 1));
  stage?.addEventListener('touchstart', (event) => {
    touchStart = event.changedTouches[0].clientX;
  }, { passive: true });
  stage?.addEventListener('touchend', (event) => {
    const distance = event.changedTouches[0].clientX - touchStart;
    if (Math.abs(distance) >= 45) showMedia(activeIndex() + (distance > 0 ? -1 : 1));
  }, { passive: true });
  gallery.querySelectorAll('img, video').forEach((media) => {
    const eventName = media.tagName === 'VIDEO' ? 'loadedmetadata' : 'load';
    media.addEventListener(eventName, fitActiveFrame);
  });

  fitActiveFrame();
  window.addEventListener('resize', fitActiveFrame, { passive: true });
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const slides = [...gallery.querySelectorAll('[data-product-slide]')];
  const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];
  const previous = gallery.querySelector('[data-gallery-previous]');
  const next = gallery.querySelector('[data-gallery-next]');
  const counter = gallery.querySelector('[data-gallery-current]');
  let current = 0;
  let touchStart = 0;

  if (slides.length < 2) return;

  const show = (index) => {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === current;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
      if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
    });
    thumbnails.forEach((thumbnail, thumbnailIndex) => {
      const active = thumbnailIndex === current;
      thumbnail.classList.toggle('is-active', active);
      thumbnail.setAttribute('aria-selected', String(active));
    });
    if (counter) counter.textContent = String(current + 1);
    if (thumbnails[current]) thumbnails[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  };

  previous?.addEventListener('click', () => show(current - 1));
  next?.addEventListener('click', () => show(current + 1));
  thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => show(index)));
  gallery.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') show(current - 1);
    if (event.key === 'ArrowRight') show(current + 1);
  });
  gallery.addEventListener('touchstart', (event) => {
    touchStart = event.changedTouches[0].clientX;
  }, { passive: true });
  gallery.addEventListener('touchend', (event) => {
    const distance = event.changedTouches[0].clientX - touchStart;
    if (Math.abs(distance) < 45) return;
    show(distance > 0 ? current - 1 : current + 1);
  }, { passive: true });
});

document.querySelectorAll('[data-collection-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-carousel-track]');
  const previous = carousel.querySelector('[data-carousel-previous]');
  const next = carousel.querySelector('[data-carousel-next]');

  if (!track || !previous || !next) return;

  const move = (direction) => {
    const card = track.querySelector('.collection-tile');
    const distance = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    track.scrollBy({ left: distance * direction, behavior: 'smooth' });
  };

  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
});

/* MY LINE conversion discovery — lightweight, no app required */
(() => {
  const current = document.querySelector('[data-current-product-card]');
  if (!current) return;
  let item;
  try { item = JSON.parse(current.textContent); } catch (e) { return; }
  const key = 'myline-recent-products';
  let recent = [];
  try { recent = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
  const previous = recent.filter((p) => p && p.handle !== item.handle).slice(0, 4);
  const section = document.querySelector('[data-recently-viewed]');
  const grid = document.querySelector('[data-recently-viewed-grid]');
  if (section && grid && previous.length) {
    grid.innerHTML = previous.map((p) => '<article class="recent-card"><a href="' + p.url + '"><img src="' + (p.image || '') + '" alt="" loading="lazy"><h3>' + p.title + '</h3><p>' + p.price + '</p></a></article>').join('');
    section.hidden = false;
  }
  recent = [item, ...previous].slice(0, 5);
  try { localStorage.setItem(key, JSON.stringify(recent)); } catch (e) {}
})();
